import { render, staticRenderFns } from "./CreateProviderNotification.vue?vue&type=template&id=45673a0c&"
import script from "./CreateProviderNotification.vue?vue&type=script&lang=js&"
export * from "./CreateProviderNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports